import { RuleCostFormula, RuleGenerationSelections } from "./rules";

export interface IDataSpell {
  id: string;
  name: string;
  type: SpellType;
  effects: {
    "1": string;
    "2": string;
    "3": string;
  };
  costs: {
    "1": string;
    "2": string;
    "3": string;
  };
  effectsSkirmish: {
    "1": string;
    "2": string;
    "3": string;
  };
  costsSkirmish: {
    "1": string;
    "2": string;
    "3": string;
  };
}

export interface ISpell {
  id: string;
  spellbookId: string;
  name: string;
  threshold: number;
  effect: string;
  effectSkirmish?: string;
  type?: SpellType;
  generation?: RuleGenerationSelections;
  costFormula?: RuleCostFormula[];
}

export enum SpellType {
  Attack = 0,
  Buff = 1,
  Debuff = 2
}
